import { render, staticRenderFns } from "./EditUserRolesPage.vue?vue&type=template&id=c52a0e30&scoped=true"
import script from "./EditUserRolesPage.vue?vue&type=script&lang=ts"
export * from "./EditUserRolesPage.vue?vue&type=script&lang=ts"
import style0 from "./EditUserRolesPage.vue?vue&type=style&index=0&id=c52a0e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52a0e30",
  null
  
)

export default component.exports